import { useInjectReducer } from 'redux-injectors';
import { useActions } from 'common/hooks';
import {
	popularCategoriesActions,
	popularCategoriesName,
	popularCategoriesReducer,
} from '../slice';

export const usePopularCategoriesSlice = () => {
	useInjectReducer({ key: popularCategoriesName, reducer: popularCategoriesReducer });
	return useActions(popularCategoriesActions);
};
